import { Module } from "vuex";
import { RootState } from "..";
import axios from "../../api/axios";
import { User } from "../../models/auth.model";
import { ILSPermissions } from "../../models/permissions.model";
import { actions } from "./auth.actions";
import { mutations } from "./auth.mutations";

export interface AuthState {
  user: User | null;
  token: string | null;
}

const initialStateFromLocalStorage = (): AuthState => {
  const token = localStorage.getItem("token");
  axios.setToken(token);
  return {
    user: null,
    token
  };
};

const state: AuthState = initialStateFromLocalStorage();

export const namespaceAuth = "auth";

export interface RootState extends RootState {
  [namespaceAuth]: AuthState;
}

export const authModule: Module<AuthState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: {
    isLoggedIn: (state: AuthState): boolean => !!state.token,
    isRefereeAdmin: (state: AuthState): boolean =>
      state.user ? state.user.permissions.includes(ILSPermissions.AdminEventsRefereeAdmin) : false,
    isAdmin: (state: AuthState): boolean => (state.user ? state.user.permissions.includes(ILSPermissions.AdminAccountAdmin) : false),
    getEmail: (state: AuthState): string => (state.user ? state.user.email : ""),
    userHasPermission: state => (permission: ILSPermissions) => (state.user ? state.user.permissions.includes(permission) : false)
  }
};

export * from "./auth.actions";
export * from "./auth.mutations";
